import { Card } from "@swot/base-components";
import { CmtsMasterDataStatusBadge } from "./CmtsMasterDataStatusBadge.js";
import { CmtsMasterDataDependencyPanel } from "./CmtsMasterDataDependencyPanel.js";
import type { CmtsMasterDataCrudEntityConfig } from "../../core/master-data/cmtsMasterDataCrudRegistry.js";
import type { DependencyCheckResult, EntityRecord } from "../../types/api.types.js";

const DETAIL_FIELDS: readonly { readonly key: string; readonly label: string }[] = [
  { key: "code", label: "Code" },
  { key: "label", label: "Label" },
  { key: "name", label: "Name" },
  { key: "description", label: "Description" },
  { key: "masterType", label: "Master type" },
  { key: "tenantId", label: "Tenant" },
  { key: "parentCategoryId", label: "Parent category id" },
  { key: "parentCategoryLabel", label: "Parent category" },
  { key: "referenceTypeId", label: "Reference type id" },
  { key: "referenceTypeLabel", label: "Reference type" },
  { key: "sortOrder", label: "Sort order" },
  { key: "effectiveFrom", label: "Effective from" },
  { key: "effectiveTo", label: "Effective to" },
  { key: "rowVersion", label: "Row version" },
  { key: "etag", label: "ETag" },
  { key: "createdAt", label: "Created" },
  { key: "updatedAt", label: "Updated" },
  { key: "createdBy", label: "Created by" },
  { key: "updatedBy", label: "Updated by" },
];

function displayValue(value: unknown): string {
  if (value === null || value === undefined || value === "") return "-";
  if (typeof value === "boolean") return value ? "Yes" : "No";
  return String(value);
}

export function CmtsMasterDataDetailPanel(props: {
  readonly config: CmtsMasterDataCrudEntityConfig;
  readonly record: EntityRecord;
  readonly dependencyCheck?: DependencyCheckResult | undefined;
}) {
  const title = displayValue(props.record.label ?? props.record.name ?? props.record.code ?? props.record.id);
  const fields = DETAIL_FIELDS.filter((field) => props.record[field.key] !== undefined && props.record[field.key] !== null && props.record[field.key] !== "");
  return (
    <section className="cmts-master-data-detail-panel">
      <Card title={title} subtitle={`${props.config.singularTitle} backend detail`}>
        <div className="cmts-master-data-detail-status"><CmtsMasterDataStatusBadge record={props.record} /></div>
        <dl className="cmts-master-data-detail-list">
          {fields.map((field) => <div key={field.key}><dt>{field.label}</dt><dd>{displayValue(props.record[field.key])}</dd></div>)}
        </dl>
      </Card>
      <CmtsMasterDataDependencyPanel config={props.config} record={props.record} dependencyCheck={props.dependencyCheck} />
    </section>
  );
}
